/**
 * @generated SignedSource<<ea6279861f87cd07f651adaa602a245d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAddNotePageMutation$variables = {
  atIndex: number;
  widgetId: string;
};
export type useAddNotePageMutation$data = {
  readonly note: {
    readonly pageCreate: {
      readonly id: string;
      readonly pages: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"NoteEdit" | "NoteEditSharedInfo_widgetNote" | "NoteNative_note">;
    };
  };
};
export type useAddNotePageMutation = {
  response: useAddNotePageMutation$data;
  variables: useAddNotePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atIndex"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "atIndex",
    "variableName": "atIndex"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbhash",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlExpiresAt",
              "storageKey": null
            },
            (v6/*: any*/),
            (v7/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v4/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddNotePageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NoteMutation",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "pageCreate",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetNotePage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NoteNative_note"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NoteEdit"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NoteEditSharedInfo_widgetNote"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAddNotePageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NoteMutation",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "pageCreate",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetNotePage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": "largeImage",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "minHeight",
                            "value": 1080
                          },
                          {
                            "kind": "Literal",
                            "name": "minWidth",
                            "value": 1080
                          }
                        ],
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "size",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": "size(minHeight:1080,minWidth:1080)"
                      },
                      {
                        "alias": "smallImage",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "minHeight",
                            "value": 100
                          },
                          {
                            "kind": "Literal",
                            "name": "minWidth",
                            "value": 100
                          }
                        ],
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "size",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": "size(minHeight:100,minWidth:100)"
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fontColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "backgroundColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentValue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fontSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fontStyle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageScale",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageTranslateX",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageTranslateY",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "remoteImageURL",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "containImage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "updatedAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isoString",
                            "storageKey": null
                          }
                        ],
                        "type": "Date",
                        "abstractKey": "__isDate"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "updatedByActor",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isActor"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoreUser",
                            "kind": "LinkedField",
                            "name": "storeUser",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Employee",
                                "kind": "LinkedField",
                                "name": "employee",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "email",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrgDescription",
                                    "kind": "LinkedField",
                                    "name": "orgDescription",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "orgIconUri",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UserActor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorecastScreen",
                            "kind": "LinkedField",
                            "name": "screen",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ScreenActor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "GroupActor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "type": "ConnectActor",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedByActorId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editingMode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOrgNote",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetNote",
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dashboard",
                    "kind": "LinkedField",
                    "name": "storecast",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "noteSize",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cbac7ca2891c6155b0ad5f938edb3a7c",
    "id": null,
    "metadata": {},
    "name": "useAddNotePageMutation",
    "operationKind": "mutation",
    "text": "mutation useAddNotePageMutation(\n  $widgetId: ID!\n  $atIndex: Int!\n) {\n  note(id: $widgetId) {\n    pageCreate(atIndex: $atIndex) {\n      id\n      pages {\n        id\n      }\n      ...NoteNative_note\n      ...NoteEdit\n      ...NoteEditSharedInfo_widgetNote\n    }\n  }\n}\n\nfragment Avatar_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        ...Avatar_employee\n        id\n      }\n      user {\n        name\n        ...Avatar_user\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    ...Avatar_groupActor\n  }\n  ... on ConnectActor {\n    __typename\n    ...Avatar_connectActor\n  }\n}\n\nfragment Avatar_connectActor on ConnectActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_groupActor on GroupActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment NoteEdit on Note {\n  id\n  ...NoteEditSharedInfo_widgetNote\n  pages {\n    id\n    ...WidgetNoteCameraMode_widgetNotePage\n    ...WidgetNotePageImageMode_widgetNotePage\n    ...NoteEditInfo_page\n    ...WidgetNoteTextModePage_widgetNotePage\n    ...WidgetNoteTextModeAccessoryView_page\n  }\n  noteSize\n}\n\nfragment NoteEditInfo_page on WidgetNotePage {\n  updatedAtDate {\n    ...FormattedDate\n  }\n  updatedByActor {\n    __typename\n    ...SignedActor_actor\n  }\n}\n\nfragment NoteEditSharedInfo_widgetNote on Note {\n  widgets {\n    storecast {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment NoteNative_note on Note {\n  id\n  editingMode\n  isOrgNote\n  title\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment PageSettingsDeleteButton_image on Image {\n  id\n  ...PageSettingsSmallImage_image\n}\n\nfragment PageSettingsLeft_page on WidgetNotePage {\n  id\n  image {\n    id\n    ...PageSettingsDeleteButton_image\n  }\n  ...WidgetNotePageBackgroundSelector_widgetNotePage\n  ...TextControl_widgetNotePage\n}\n\nfragment PageSettingsSmallImage_image on Image {\n  id\n  smallImage: size(minWidth: 100, minHeight: 100) {\n    url\n    id\n  }\n}\n\nfragment PageSettings_page on WidgetNotePage {\n  id\n  image {\n    id\n    ...PageSettingsDeleteButton_image\n  }\n  ...TextControl_widgetNotePage\n  ...WidgetNotePageBackgroundSelector_widgetNotePage\n}\n\nfragment SignedActorBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on ConnectActor {\n    employee {\n      __typename\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n}\n\nfragment SignedActorText_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        id\n      }\n      user {\n        name\n        email\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      name\n      id\n    }\n    identifyingName\n  }\n  ... on ConnectActor {\n    __typename\n    identifyingName\n    employee {\n      name\n      id\n    }\n  }\n}\n\nfragment SignedActor_actor on Actor {\n  __isActor: __typename\n  ...Avatar_actor\n  ...SignedActorText_actor\n  ...SignedActorBadge_actor\n}\n\nfragment TextControl_widgetNotePage on WidgetNotePage {\n  id\n  fontSize\n  fontStyle\n  backgroundColor\n  image {\n    __typename\n    id\n  }\n  ...useToggleFontColor_page\n  ...useNoteWidgetStyleText_widgetNotePage\n}\n\nfragment WidgetNoteCameraMode_widgetNotePage on WidgetNotePage {\n  ...WidgetNoteText_page\n}\n\nfragment WidgetNotePageBackgroundSelector_widgetNotePage on WidgetNotePage {\n  id\n  backgroundColor\n  fontStyle\n  fontSize\n}\n\nfragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  image {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  imageScale\n  imageTranslateX\n  imageTranslateY\n  remoteImageURL\n  containImage\n}\n\nfragment WidgetNotePageImageMode_widgetNotePage on WidgetNotePage {\n  ...WidgetNoteText_page\n  id\n  fontColor\n  ...useToggleFontColor_page\n  ...useNoteWidgetStyleText_widgetNotePage\n}\n\nfragment WidgetNotePage_widgetNotePage on WidgetNotePage {\n  id\n  currentValue\n  version\n  ...useNoteWidgetStyleText_widgetNotePage\n  ...WidgetNotePageBackground_widgetNotePage\n}\n\nfragment WidgetNoteTextModeAccessoryView_page on WidgetNotePage {\n  id\n  ...PageSettingsLeft_page\n  ...PageSettings_page\n}\n\nfragment WidgetNoteTextModePage_widgetNotePage on WidgetNotePage {\n  currentValue\n  updatedByActorId\n  id\n  ...WidgetNotePageBackground_widgetNotePage\n  ...useNoteWidgetStyleText_widgetNotePage\n}\n\nfragment WidgetNoteText_page on WidgetNotePage {\n  currentValue\n  ...useNoteWidgetStyleText_widgetNotePage\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n\nfragment useNoteWidgetStyleText_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  fontSize\n  fontStyle\n  fontColor\n  image {\n    id\n  }\n}\n\nfragment useToggleFontColor_page on WidgetNotePage {\n  id\n  fontColor\n  ...useNoteWidgetStyleText_widgetNotePage\n}\n"
  }
};
})();

(node as any).hash = "a83d83e87bc6023dc86f21fcde1a0a25";

export default node;
